import { Post } from 'Xhr/Xhr';
import Cookies from 'js-cookie';
import { env } from 'env';

export const GetMessageList = (
  setGatheredData,
  parameter
) => {
  const IdwebUser =
    Cookies.get('user') &&
    JSON.parse(Cookies.get('user'))?.Id;

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_GET_SMS_LIST}`,
    true,
    {
      Id: IdwebUser,
    }
  ).then((response) => {
    if (response) {
      if (response?.data?.resCode === 1) {
        setGatheredData({
          [parameter]: response.data.Data.SmsList,
        });
      }
    }
  });
};
